export const URL_UPDATE_COMMERCE = {
  GET_TIPO_DOCUMENTO: `${process.env.REACT_APP_URL_SERVICE_COMMERCE}/type-doc`,
  GET_STATUS_UPDATE: `${process.env.REACT_APP_URL_SERVICE_COMMERCE}/update-commerce/consult-status`,
  LISTAR_STATUS: `${process.env.REACT_APP_URL_SERVICE_COMMERCE}/update-commerce/listar-status`,
  ACTUALIZAR: `${process.env.REACT_APP_URL_SERVICE_COMMERCE}/update-commerce/actualizar`,
  CORREGIR_CONSULT: `${process.env.REACT_APP_URL_SERVICE_COMMERCE}/update-commerce/corregir-consult`,
  CORREGIR: `${process.env.REACT_APP_URL_SERVICE_COMMERCE}/update-commerce/corregir`,
  VALIDAR_CONSULT: `${process.env.REACT_APP_URL_SERVICE_COMMERCE}/update-commerce/validar-consult`,
  VALIDAR: `${process.env.REACT_APP_URL_SERVICE_COMMERCE}/update-commerce/validar`,
  VALIDAR_NEXT: `${process.env.REACT_APP_URL_SERVICE_COMMERCE}/update-commerce/validar-next`,
  UPLOAD_FILE: `${process.env.REACT_APP_URL_SERVICE_COMMERCE}/update-commerce/upload-file`,
  DOWNLOAD_FILE: `${process.env.REACT_APP_URL_SERVICE_COMMERCE}/update-commerce/download-file`,
};
